import script from "./BackgroundSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./BackgroundSetting.vue?vue&type=script&setup=true&lang=ts"

import "./BackgroundSetting.vue?vue&type=style&index=0&id=7fa6feb1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa6feb1"]])

export default __exports__